module.exports = __webpack_public_path__ + "static/3-2-197b37112fa923a3fd7843f79566dc87.png";